(function () {
  if (window.jpcrop1Init) return;
  window.jpcrop1Init = true;

  var dataEl = document.getElementById('jpcrop1-data');
  if (!dataEl) return;
  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var APP_NAME = 'properties[Upload Eyes Picture]';
  // frame shape per piece (long side : short side), measured from the product photos so the
  // photo covers the whole engraving plate. Vertical frames landscape and is turned upright.
  var RATIOS = { h: 6, v: 3.2, b: 4.65 };
  var OUT_LONG = 3000;
  var MAX_SRC = 4096;
  var MAX_PIX = 16000000;
  var MIN_GOOD = 450;

  var matIdx = -1, styleIdx = -1;
  (DATA.options || []).forEach(function (n, i) {
    if (/material|metal|colou?r/i.test(n)) matIdx = i;
    if (/style/i.test(n)) styleIdx = i;
  });

  /* ---------------- state ---------------- */
  var S = {
    file: null,        // original file (kept in memory only)
    src: null,         // working canvas or bitmap
    W: 0, H: 0,
    s: 1, cx: 0, cy: 0, r90: 0, tilt: 0,
    guides: true,
    crop: null,        // last confirmed transform {s,cx,cy,r90,tilt,fw}
    cropCanvas: null,  // landscape render of the confirmed crop at the piece's shape
    phase: 'idle',     // idle | busy | done | error
    sentStyle: null,
    asIs: false,
    lastVariant: null
  };

  /* ---------------- helpers ---------------- */
  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function appInput() {
    var all = qa('input[type="file"]');
    for (var i = 0; i < all.length; i++) if (all[i].name === APP_NAME) return all[i];
    return null;
  }
  function appWrap(inp) { return inp ? (inp.closest('.previewSection') || inp.closest('.optionList') || inp.parentNode) : null; }
  function appPreviewImg(inp) {
    var w = appWrap(inp);
    if (!w) return null;
    var im = w.querySelector('img');
    var src = im ? (im.getAttribute('src') || '') : '';
    // the app shows a loader gif from its own CDN while uploading; only a Shopify file counts
    return im && /(cdn\.shopify\.com|\/cdn\/shop\/)/.test(src) && !/loader/i.test(src) ? im : null;
  }
  function currentVariantId() {
    var f = qa('form[action*="/cart/add"]');
    for (var i = 0; i < f.length; i++) {
      var el = f[i].querySelector('[name="id"]');
      if (el && el.value && !f[i].querySelector('[name="contact[email]"]')) return String(el.value);
    }
    var m = location.search.match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }
  function currentVariant() {
    var id = currentVariantId();
    var vs = DATA.variants || [];
    for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === id) return vs[i];
    return vs[0] || null;
  }
  function material() {
    var v = currentVariant();
    var m = v && matIdx > -1 ? String(v.o[matIdx] || '') : '';
    if (/silver|steel/i.test(m)) return 'silver';
    if (/black/i.test(m)) return 'black';
    if (/rose/i.test(m)) return 'rose';
    return 'gold';
  }
  function materialLabel() {
    var v = currentVariant();
    return v && matIdx > -1 ? String(v.o[matIdx] || '') : '';
  }
  function isVertical() {
    if (DATA.kind !== 'bar') return false;
    var v = currentVariant();
    return !!(v && styleIdx > -1 && /vert/i.test(String(v.o[styleIdx] || '')));
  }
  function ratio() {
    if (DATA.kind === 'bracelet') return RATIOS.b;
    return isVertical() ? RATIOS.v : RATIOS.h;
  }
  function kindLabel() {
    if (DATA.kind === 'bracelet') return 'bracelet';
    return isVertical() ? 'vertical bar' : 'horizontal bar';
  }
  var toastT;
  function toast(msg) {
    var t = q('.jpcrop1-toast');
    if (!t) { t = document.createElement('div'); t.className = 'jpcrop1-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }
  function later(fn, ms) { return setTimeout(fn, ms || 0); }
  function frame(fn) { if (document.hidden) return setTimeout(fn, 16); return requestAnimationFrame(fn); }

  /* ---------------- card (in the app field) ---------------- */
  var card, box, msgEl, pickInput, mockCanvas;

  function mountCard() {
    var inp = appInput();
    if (!inp) return false;
    var wrap = appWrap(inp);
    if (!wrap) return false;
    if (wrap.querySelector('.jpcrop1-card')) return true;
    var tpl = document.getElementById('jpcrop1-tpl');
    var node = tpl.content.firstElementChild.cloneNode(true);
    wrap.classList.add('jpcrop1-hideapp');
    var label = wrap.querySelector('.labelTitle');
    if (label && label.nextSibling) wrap.insertBefore(node, label.nextSibling);
    else wrap.insertBefore(node, wrap.firstChild);
    card = node;
    if (!document.getElementById('jpcrop1-css2')) {
      var st = document.createElement('style');
      st.id = 'jpcrop1-css2';
      st.textContent = '.jpcrop1-hideapp > span.danger{display:none !important;}';
      document.head.appendChild(st);
    }
    box = q('.jpcrop1-box', card);
    msgEl = q('.jpcrop1-msg', card);
    pickInput = q('.jpcrop1-file', card);
    mockCanvas = q('.jpcrop1-mock', card);
    pickInput.addEventListener('change', function () {
      var f = pickInput.files && pickInput.files[0];
      pickInput.value = '';
      if (f) openWith(f);
    });
    card.addEventListener('click', function (e) {
      var b = e.target.closest('[data-jpc]');
      if (!b) return;
      var a = b.getAttribute('data-jpc');
      if (a === 'pick') { e.preventDefault(); pick(); }
      if (a === 'edit') { e.preventDefault(); reopen(); }
      if (a === 'tips') { e.preventDefault(); openModal(true); }
    });
    paintCard();
    return true;
  }

  function pick() {
    if (!pickInput) return;
    try { pickInput.click(); } catch (e) {}
  }

  function setMsg(t) {
    if (!msgEl) return;
    msgEl.textContent = t || '';
    msgEl.classList.toggle('is-on', !!t);
  }

  function paintCard() {
    if (!box) return;
    box.classList.toggle('is-done', S.phase === 'done');
    box.classList.toggle('is-busy', S.phase === 'busy');
    if (mockCanvas) mockCanvas.style.display = S.asIs ? 'none' : '';
    if ((S.phase === 'done' || S.phase === 'busy') && mockCanvas && !S.asIs) { if (!drawPhotoMock(mockCanvas, S.cropCanvas)) drawMock(mockCanvas, S.cropCanvas, 520); }
    var edit = q('[data-jpc="edit"]', card);
    if (edit) edit.style.display = S.asIs ? 'none' : '';
  }

  /* ---------------- product preview drawing ---------------- */
  var METALS = {
    gold:   { stops: ['#F7E7BC', '#E2C17E', '#C49A52', '#B08440', '#E9CD8F'], rim: '#9C7536', ink: 'multiply', inkA: 0.92 },
    rose:   { stops: ['#F8DDD3', '#E8B9A6', '#C98C77', '#B57A66', '#EBC3B3'], rim: '#9B6656', ink: 'multiply', inkA: 0.9 },
    silver: { stops: ['#FBFBFB', '#E4E4E4', '#BDBDBD', '#A4A4A4', '#E9E9E9'], rim: '#8E8E8E', ink: 'multiply', inkA: 0.95 },
    black:  { stops: ['#4A4A4A', '#2A2A2A', '#161616', '#0E0E0E', '#333333'], rim: '#050505', ink: 'screen', inkA: 0.9 }
  };

  function metalFill(g, x, y, w, h, vertical, m) {
    var gr = vertical ? g.createLinearGradient(x, y, x + w, y) : g.createLinearGradient(x, y, x, y + h);
    var st = m.stops;
    for (var i = 0; i < st.length; i++) gr.addColorStop(i / (st.length - 1), st[i]);
    return gr;
  }

  function rr(g, x, y, w, h, r) {
    r = Math.min(r, w / 2, h / 2);
    g.beginPath();
    g.moveTo(x + r, y);
    g.lineTo(x + w - r, y); g.quadraticCurveTo(x + w, y, x + w, y + r);
    g.lineTo(x + w, y + h - r); g.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
    g.lineTo(x + r, y + h); g.quadraticCurveTo(x, y + h, x, y + h - r);
    g.lineTo(x, y + r); g.quadraticCurveTo(x, y, x + r, y);
    g.closePath();
  }

  // greyscale copy of the crop with auto levels: the darkest lines engrave deepest, the
  // brightest third becomes bare metal, so it reads like a laser etch rather than a print
  var inkCache = { key: null, c: null };
  function inkOf(crop, light) {
    if (!crop) return null;
    var key = crop.__jpcId + (light ? 'L' : 'D');
    if (inkCache.key === key) return inkCache.c;
    var w = Math.min(crop.width, 900), h = Math.max(2, Math.round(w * crop.height / crop.width));
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var g = c.getContext('2d');
    g.drawImage(crop, 0, 0, w, h);
    try {
      var d = g.getImageData(0, 0, w, h), p = d.data, i, l, n = p.length / 4, hist = [];
      for (l = 0; l < 256; l++) hist.push(0);
      for (i = 0; i < p.length; i += 4) { l = Math.round(0.299 * p[i] + 0.587 * p[i + 1] + 0.114 * p[i + 2]); p[i] = l; hist[l]++; }
      var acc = 0, lo = 0, hi = 255, qhi = light ? 0.98 : 0.70, qlo = light ? 0.02 : 0.03;
      for (l = 0; l < 256; l++) { acc += hist[l]; if (acc < n * qlo) lo = l; if (acc < n * qhi) hi = l; }
      if (hi - lo < 40) hi = lo + 40;
      for (i = 0; i < p.length; i += 4) {
        l = (p[i] - lo) / (hi - lo); l = l < 0 ? 0 : l > 1 ? 1 : l;
        // black plating shows a positive grey print (as in the product photo); metal shows a dark etch
        l = light ? 28 + l * 187 : Math.pow(l, 0.85) * 255;
        p[i] = p[i + 1] = p[i + 2] = l;
      }
      g.putImageData(d, 0, 0);
    } catch (e) {}
    inkCache = { key: key, c: c };
    return c;
  }

  // draws the crop into the zone (zx,zy,zw,zh); vertical rotates it 90 clockwise
  function engrave(g, crop, zx, zy, zw, zh, vertical, m) {
    if (!crop) return;
    var ink = inkOf(crop, m.ink === 'screen');
    var off = document.createElement('canvas');
    off.width = Math.max(2, Math.round(zw)); off.height = Math.max(2, Math.round(zh));
    var o = off.getContext('2d');
    if (vertical) {
      o.translate(off.width, 0); o.rotate(Math.PI / 2);
      o.drawImage(ink, 0, 0, off.height, off.width);
      o.setTransform(1, 0, 0, 1, 0, 0);
    } else {
      o.drawImage(ink, 0, 0, off.width, off.height);
    }
    // soft feather at the far ends so the engraving melts into the metal
    o.globalCompositeOperation = 'destination-in';
    var fg = vertical ? o.createLinearGradient(0, 0, 0, off.height) : o.createLinearGradient(0, 0, off.width, 0);
    fg.addColorStop(0, 'rgba(0,0,0,0)'); fg.addColorStop(0.05, 'rgba(0,0,0,1)');
    fg.addColorStop(0.95, 'rgba(0,0,0,1)'); fg.addColorStop(1, 'rgba(0,0,0,0)');
    o.fillStyle = fg; o.fillRect(0, 0, off.width, off.height);
    g.save();
    g.globalCompositeOperation = m.ink;
    g.globalAlpha = m.inkA;
    g.drawImage(off, zx, zy, zw, zh);
    g.restore();
  }

  function sheen(g, x, y, w, h, vertical) {
    g.save();
    var s = vertical ? g.createLinearGradient(x, y, x + w, y) : g.createLinearGradient(x, y, x, y + h);
    s.addColorStop(0, 'rgba(255,255,255,.45)'); s.addColorStop(0.18, 'rgba(255,255,255,0)');
    s.addColorStop(0.8, 'rgba(0,0,0,0)'); s.addColorStop(1, 'rgba(0,0,0,.12)');
    g.fillStyle = s; g.fillRect(x, y, w, h);
    g.restore();
  }

  function chainLine(g, pts, m) {
    g.save();
    g.strokeStyle = m === METALS.black ? '#2B2B2B' : m.rim;
    g.lineWidth = 2.2; g.setLineDash([5, 3]); g.lineCap = 'round';
    g.beginPath(); g.moveTo(pts[0][0], pts[0][1]);
    for (var i = 1; i < pts.length; i++) g.lineTo(pts[i][0], pts[i][1]);
    g.stroke(); g.restore();
  }

  function drawMock(cv, crop, cssW) {
    var m = METALS[material()] || METALS.gold;
    var vertical = isVertical();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W, H;
    if (vertical) { W = 220; H = 330; } else { W = 600; H = DATA.kind === 'bracelet' ? 160 : 170; }
    cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
    cv.classList.toggle('is-v', vertical);
    cv.classList.remove('is-photo');
    cv.__jpcTok = (cv.__jpcTok || 0) + 1;
    var g = cv.getContext('2d');
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
    g.clearRect(0, 0, W, H);

    if (vertical) {
      // bar about 1:3.5, bail on top, engraving fills the face
      var bw = 62, bh = 218, bx = (W - bw) / 2, by = 82;
      chainLine(g, [[W / 2 - 54, 0], [W / 2 - 8, 56]], m);
      chainLine(g, [[W / 2 + 54, 0], [W / 2 + 8, 56]], m);
      g.save(); g.shadowColor = 'rgba(0,0,0,.18)'; g.shadowBlur = 12; g.shadowOffsetY = 5;
      rr(g, W / 2 - 11, 52, 22, 34, 6); g.fillStyle = metalFill(g, W / 2 - 11, 52, 22, 34, true, m); g.fill();
      rr(g, bx, by, bw, bh, 4); g.fillStyle = metalFill(g, bx, by, bw, bh, true, m); g.fill(); g.restore();
      rr(g, W / 2 - 6, 58, 12, 18, 4); g.fillStyle = 'rgba(0,0,0,.22)'; g.fill();
      engrave(g, crop, bx + 3, by + 3, bw - 6, bh - 6, true, m);
      sheen(g, bx, by, bw, bh, true);
      rr(g, bx, by, bw, bh, 4); g.strokeStyle = m.rim; g.lineWidth = 1; g.stroke();
      return;
    }

    if (DATA.kind === 'bracelet') {
      // plate with slots near both ends, curb chain stubs, engraving fills between the slots
      var pw = 492, ph = 82, px = (W - pw) / 2, py = (H - ph) / 2;
      g.save();
      for (var k = 0; k < 2; k++) {
        var sx = k ? px + pw - 6 : px - 48;
        for (var j = 0; j < 3; j++) {
          var lx = k ? sx + j * 18 : sx + (2 - j) * 18 - 0;
          rr(g, lx, py + 18 + (j % 2 ? 6 : 0), 26, 36, 11);
          g.lineWidth = 7; g.strokeStyle = metalFill(g, lx, py, 26, 60, false, m); g.stroke();
        }
      }
      g.restore();
      g.save(); g.shadowColor = 'rgba(0,0,0,.2)'; g.shadowBlur = 14; g.shadowOffsetY = 6;
      rr(g, px, py, pw, ph, 18); g.fillStyle = metalFill(g, px, py, pw, ph, false, m); g.fill(); g.restore();
      var slw = 13, slh = 30;
      g.fillStyle = '#F1EBE0';
      rr(g, px + 18, py + (ph - slh) / 2, slw, slh, 3); g.fill();
      rr(g, px + pw - 18 - slw, py + (ph - slh) / 2, slw, slh, 3); g.fill();
      engrave(g, crop, px + 36, py + 4, pw - 72, ph - 8, false, m);
      sheen(g, px, py, pw, ph, false);
      rr(g, px, py, pw, ph, 18); g.strokeStyle = m.rim; g.lineWidth = 1; g.stroke();
      return;
    }

    // horizontal bar with jump rings at the top corners, engraving fills the face
    var hw = 520, hh = 96, hx = (W - hw) / 2, hy = 52;
    chainLine(g, [[0, 6], [hx + 8, hy - 2]], m);
    chainLine(g, [[W, 6], [hx + hw - 8, hy - 2]], m);
    g.save(); g.lineWidth = 3; g.strokeStyle = m.rim;
    g.beginPath(); g.arc(hx + 9, hy + 2, 6, 0, Math.PI * 2); g.stroke();
    g.beginPath(); g.arc(hx + hw - 9, hy + 2, 6, 0, Math.PI * 2); g.stroke(); g.restore();
    g.save(); g.shadowColor = 'rgba(0,0,0,.2)'; g.shadowBlur = 14; g.shadowOffsetY = 6;
    rr(g, hx, hy, hw, hh, 3); g.fillStyle = metalFill(g, hx, hy, hw, hh, false, m); g.fill(); g.restore();
    engrave(g, crop, hx + 3, hy + 3, hw - 6, hh - 6, false, m);
    sheen(g, hx, hy, hw, hh, false);
    rr(g, hx, hy, hw, hh, 3); g.strokeStyle = m.rim; g.lineWidth = 1; g.stroke();
  }

  /* ---------------- photo preview: assets/jpcrop1-preview.js draws on the real product photos ---------------- */
  function drawPhotoMock(cv, crop) {
    var P = window.jpcrop1Preview;
    if (!P) return false;
    return P.draw(cv, crop, currentVariant(), material());
  }

  /* ---------------- image loading ---------------- */
  function loadFile(file) {
    return new Promise(function (resolve, reject) {
      function finish(source, w, h) {
        if (!w || !h) return reject(new Error('empty'));
        var k = Math.min(1, MAX_SRC / Math.max(w, h), Math.sqrt(MAX_PIX / (w * h)));
        var c = document.createElement('canvas');
        c.width = Math.max(1, Math.round(w * k)); c.height = Math.max(1, Math.round(h * k));
        var g = c.getContext('2d');
        g.imageSmoothingQuality = 'high';
        g.drawImage(source, 0, 0, c.width, c.height);
        if (source.close) { try { source.close(); } catch (e) {} }
        resolve({ c: c, srcW: w, srcH: h, k: k });
      }
      function viaImg() {
        var url = URL.createObjectURL(file);
        var im = new Image();
        im.onload = function () { URL.revokeObjectURL(url); finish(im, im.naturalWidth, im.naturalHeight); };
        im.onerror = function () { URL.revokeObjectURL(url); reject(new Error('decode')); };
        im.src = url;
      }
      if (window.createImageBitmap) {
        var p;
        try { p = createImageBitmap(file, { imageOrientation: 'from-image' }); } catch (e) { p = null; }
        if (p && p.then) { p.then(function (b) { finish(b, b.width, b.height); }).catch(viaImg); return; }
      }
      viaImg();
    });
  }

  /* ---------------- modal ---------------- */
  var doneTop, M, stage, cv, ctx, zoomEl, tiltEl, zv, tv, applyBtn, pvCanvas, warnEl, hintEl, loadEl, failEl, workEl, lastFocus;
  var stageW = 0, stageH = 0, FW = 0, FH = 0, FX = 0, FY = 0;

  function buildModal() {
    if (M) return;
    var tpl = document.getElementById('jpcrop1-mtpl');
    M = tpl.content.firstElementChild.cloneNode(true);
    document.body.appendChild(M);
    stage = q('.jpcrop1-stage', M); cv = q('canvas', stage); ctx = cv.getContext('2d');
    zoomEl = q('#jpcrop1-zoom', M); tiltEl = q('#jpcrop1-tilt', M);
    zv = q('[data-jpc="zv"]', M); tv = q('[data-jpc="tv"]', M);
    applyBtn = q('.jpcrop1-foot [data-jpc="apply"]', M); doneTop = q('.jpcrop1-done-top', M); pvCanvas = q('.jpcrop1-pvc', M);
    // Shopify's theme preview bar covers the bottom of the screen on draft previews
    if (document.getElementById('preview-bar-iframe')) M.classList.add('is-previewbar');
    warnEl = q('.jpcrop1-warn', M); hintEl = q('.jpcrop1-hint', M); loadEl = q('.jpcrop1-load', M);
    failEl = q('.jpcrop1-fail', M); workEl = q('.jpcrop1-work', M);

    M.addEventListener('click', function (e) {
      var b = e.target.closest('[data-jpc]');
      if (!b) return;
      var a = b.getAttribute('data-jpc');
      if (a === 'close') closeModal();
      else if (a === 'apply') apply();
      else if (a === 'pick') pick();
      else if (a === 'reset') { S.r90 = 0; S.tilt = 0; tiltEl.value = 0; fitInitial(); syncUI(); draw(); }
      else if (a === 'rot') { rotate90(); }
      else if (a === 'asis') { sendAsIs(); }
    });
    M.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closeModal(); return; }
      if (e.key === 'Tab') trapTab(e);
    });
    zoomEl.addEventListener('input', function () {
      var ns = sliderToScale(+zoomEl.value);
      zoomAbout(ns, 0, 0);
      hideHint();
    });
    tiltEl.addEventListener('input', function () {
      S.tilt = (+tiltEl.value) / 10;
      clampAll(); syncUI(); draw(); hideHint();
    });
    bindGestures();
    window.addEventListener('resize', function () { if (M.classList.contains('is-open')) { layout(); draw(); } });
  }

  function trapTab(e) {
    var f = qa('button:not([disabled]),input,[tabindex="0"]', M).filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  var scrollY0 = 0;
  function lockScroll(on) {
    var de = document.documentElement;
    if (on) { scrollY0 = window.scrollY; de.classList.add('jpcrop1-lock'); }
    else { de.classList.remove('jpcrop1-lock'); window.scrollTo(0, scrollY0); }
  }

  function openModal(tipsOnly) {
    buildModal();
    lastFocus = document.activeElement;
    M.classList.add('is-open');
    lockScroll(true);
    var hasImg = !!S.src;
    workEl.style.display = hasImg ? '' : 'none';
    failEl.classList.remove('is-on');
    if (tipsOnly && !hasImg) {
      q('.jpcrop1-h', M).innerHTML = 'Photo <em>tips</em>';
      applyBtn.textContent = 'Choose photo';
      applyBtn.disabled = false;
      applyBtn.setAttribute('data-jpc', 'pick');
      doneTop.style.display = 'none';
    } else {
      q('.jpcrop1-h', M).innerHTML = 'Frame <em>their eyes</em>';
      applyBtn.textContent = 'Done';
      applyBtn.setAttribute('data-jpc', 'apply');
      applyBtn.disabled = !hasImg;
      doneTop.style.display = '';
      doneTop.disabled = !hasImg;
    }
    later(function () { var x = q('.jpcrop1-x', M); if (x) x.focus(); }, 30);
    if (hasImg) later(function () { layout(); draw(); }, 0);
  }

  function closeModal() {
    if (!M) return;
    M.classList.remove('is-open');
    lockScroll(false);
    // restore the last confirmed crop so a cancelled edit changes nothing
    if (S.crop) { S.s = S.crop.s; S.cx = S.crop.cx; S.cy = S.crop.cy; S.r90 = S.crop.r90; S.tilt = S.crop.tilt; }
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  function openWith(file) {
    if (!/^image\//.test(file.type || '') && !/\.(heic|heif|jpe?g|png|webp|gif|tiff?|bmp)$/i.test(file.name || '')) {
      setMsg('Please choose a photo file (JPG, PNG or HEIC).');
      return;
    }
    setMsg('');
    S.file = file; S.src = null; S.asIs = false;
    buildModal();
    openModal(false);
    workEl.style.display = '';
    loadEl.style.display = 'flex';
    applyBtn.disabled = true; doneTop.disabled = true;
    ctx && ctx.clearRect(0, 0, cv.width, cv.height);
    loadFile(file).then(function (r) {
      S.src = r.c; S.W = r.c.width; S.H = r.c.height; S.k = r.k;
      S.r90 = 0; S.tilt = 0; tiltEl.value = 0; S.crop = null;
      loadEl.style.display = 'none';
      hintEl.classList.remove('is-off');
      layout(); fitInitial(); syncUI(); draw();
      applyBtn.disabled = false; doneTop.disabled = false;
    }).catch(function () {
      loadEl.style.display = 'none';
      workEl.style.display = 'none';
      failEl.classList.add('is-on');
      var heic = /\.(heic|heif)$/i.test(file.name || '') || /hei[cf]/i.test(file.type || '');
      q('[data-jpc="failmsg"]', M).textContent = heic
        ? 'This browser cannot open iPhone HEIC photos for framing. Choose a JPG or screenshot of the photo, or send it as it is and our designers will frame it for you.'
        : 'This photo could not be opened here. Choose another, or send it as it is and our designers will frame it for you.';
      applyBtn.disabled = true; doneTop.disabled = true;
    });
  }

  function reopen() {
    if (!S.src) { pick(); return; }
    if (S.crop) { S.s = S.crop.s; S.cx = S.crop.cx; S.cy = S.crop.cy; S.r90 = S.crop.r90; S.tilt = S.crop.tilt; tiltEl && (tiltEl.value = Math.round(S.tilt * 10)); }
    openModal(false);
    later(function () { layout(); if (S.crop && S.crop.fw && FW) { var k = FW / S.crop.fw; S.s *= k; S.cx *= k; S.cy *= k; } clampAll(); syncUI(); draw(); }, 0);
  }

  /* ---------------- geometry ---------------- */
  function layout() {
    var r = stage.getBoundingClientRect();
    stageW = Math.max(1, r.width); stageH = Math.max(1, r.height);
    var dpr = Math.min(window.devicePixelRatio || 1, 2.5);
    cv.width = Math.round(stageW * dpr); cv.height = Math.round(stageH * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var pad = Math.max(14, stageW * 0.05);
    var R = ratio();
    FW = stageW - pad * 2; FH = FW / R;
    if (FH > stageH * 0.6) { FH = stageH * 0.6; FW = FH * R; }
    FX = stageW / 2; FY = stageH / 2;
  }
  function ang() { return S.r90 * Math.PI / 2 + S.tilt * Math.PI / 180; }
  function ext() {
    var a = ang(), c = Math.abs(Math.cos(a)), s = Math.abs(Math.sin(a));
    return { ex: (FW * c + FH * s) / 2, ey: (FW * s + FH * c) / 2 };
  }
  function minScale() { var e = ext(); return Math.max(2 * e.ex / S.W, 2 * e.ey / S.H); }
  function maxScale() { return Math.max(minScale() * 2.5, FW / 220); }
  function clampAll() {
    var mn = minScale(), mx = maxScale();
    if (S.s < mn) S.s = mn;
    if (S.s > mx) S.s = mx;
    var a = ang(), c = Math.cos(a), s = Math.sin(a), e = ext();
    var dx = -S.cx, dy = -S.cy;
    var lx = dx * c + dy * s, ly = -dx * s + dy * c;
    var lxm = Math.max(0, S.W * S.s / 2 - e.ex), lym = Math.max(0, S.H * S.s / 2 - e.ey);
    lx = Math.max(-lxm, Math.min(lxm, lx));
    ly = Math.max(-lym, Math.min(lym, ly));
    dx = lx * c - ly * s; dy = lx * s + ly * c;
    S.cx = -dx; S.cy = -dy;
  }
  function fitInitial() {
    S.s = minScale();
    // eyes usually sit a little above the middle of a face photo
    var a = ang(), c = Math.cos(a), s = Math.sin(a);
    var wantLy = (S.H > S.W * 1.05 && S.r90 % 2 === 0) ? -0.08 * S.H * S.s : 0;
    var dx = -wantLy * s, dy = wantLy * c;
    S.cx = -dx; S.cy = -dy;
    clampAll();
  }
  function rotate90() {
    var keepRel = S.s / minScale();
    S.r90 = (S.r90 + 1) % 4;
    S.s = minScale() * keepRel;
    S.cx = 0; S.cy = 0;
    clampAll(); syncUI(); draw(); hideHint();
  }
  function scaleToSlider(s) {
    var mn = minScale(), mx = maxScale();
    if (mx <= mn) return 0;
    return Math.round(1000 * Math.log(s / mn) / Math.log(mx / mn));
  }
  function sliderToScale(v) {
    var mn = minScale(), mx = maxScale();
    return mn * Math.pow(mx / mn, v / 1000);
  }
  function zoomAbout(ns, px, py) {
    var os = S.s;
    var mn = minScale(), mx = maxScale();
    ns = Math.max(mn, Math.min(mx, ns));
    var k = ns / os;
    S.cx = px - (px - S.cx) * k;
    S.cy = py - (py - S.cy) * k;
    S.s = ns;
    clampAll(); syncUI(); draw();
  }

  function syncUI() {
    if (!zoomEl) return;
    var v = scaleToSlider(S.s);
    zoomEl.value = v;
    zoomEl.style.setProperty('--p', (v / 10) + '%');
    zv.textContent = (S.s / minScale()).toFixed(1) + 'x';
    var tp = ((+tiltEl.value + 150) / 300) * 100;
    tiltEl.style.setProperty('--p', tp + '%');
    tv.innerHTML = (S.tilt > 0 ? '+' : '') + S.tilt.toFixed(1) + '&deg;';
    var srcPx = FW / S.s / (S.k || 1);
    if (warnEl) {
      var low = srcPx < MIN_GOOD;
      warnEl.textContent = low ? 'Low detail at this zoom. It will still work, but a closer or sharper photo engraves finer lashes.' : '';
      warnEl.classList.toggle('is-on', low);
    }
  }

  /* ---------------- drawing the stage ---------------- */
  var drawQueued = false;
  function draw() {
    if (drawQueued) return;
    drawQueued = true;
    frame(function () { drawQueued = false; drawNow(); });
  }
  function drawNow() {
    if (!ctx || !S.src) return;
    var g = ctx;
    g.save();
    g.clearRect(0, 0, stageW, stageH);
    g.fillStyle = '#1B1916'; g.fillRect(0, 0, stageW, stageH);
    g.translate(FX + S.cx, FY + S.cy);
    g.rotate(ang());
    g.scale(S.s, S.s);
    g.imageSmoothingQuality = 'high';
    g.drawImage(S.src, -S.W / 2, -S.H / 2);
    g.restore();

    var x0 = FX - FW / 2, y0 = FY - FH / 2;
    // veil outside the frame
    g.save();
    g.fillStyle = 'rgba(17,15,12,.66)';
    g.beginPath(); g.rect(0, 0, stageW, stageH); g.rect(x0, y0, FW, FH); g.fill('evenodd');
    // frame
    g.strokeStyle = 'rgba(255,255,255,.9)'; g.lineWidth = 1; g.strokeRect(x0 + .5, y0 + .5, FW - 1, FH - 1);
    // gold corners
    g.strokeStyle = '#D9B46A'; g.lineWidth = 3; g.lineCap = 'round';
    var L = Math.min(22, FH * 0.35);
    [[x0, y0, 1, 1], [x0 + FW, y0, -1, 1], [x0, y0 + FH, 1, -1], [x0 + FW, y0 + FH, -1, -1]].forEach(function (c) {
      g.beginPath(); g.moveTo(c[0] + c[2] * L, c[1]); g.lineTo(c[0], c[1]); g.lineTo(c[0], c[1] + c[3] * L); g.stroke();
    });
    // faint level line through the middle of the frame, a guide for straightening
    g.setLineDash([3, 4]); g.lineWidth = 1; g.strokeStyle = 'rgba(255,255,255,.35)';
    g.beginPath(); g.moveTo(x0 + 8, FY); g.lineTo(x0 + FW - 8, FY); g.stroke();
    g.setLineDash([]);
    g.restore();
    schedulePreview();
  }

  /* ---------------- render the crop ---------------- */
  var cropSeq = 0;
  function renderCrop(state, longSide) {
    var fw = FW, fh = FH;
    var srcPx = fw / state.s;
    // the order file is 3000 px on the long side at the piece's shape
    var ow = longSide || OUT_LONG;
    var oh = Math.round(ow * fh / fw);
    var c = document.createElement('canvas'); c.width = ow; c.height = oh;
    var g = c.getContext('2d');
    g.fillStyle = '#ffffff'; g.fillRect(0, 0, ow, oh);
    g.imageSmoothingQuality = 'high';
    g.scale(ow / fw, oh / fh);
    g.translate(fw / 2 + state.cx, fh / 2 + state.cy);
    g.rotate(state.r90 * Math.PI / 2 + state.tilt * Math.PI / 180);
    g.scale(state.s, state.s);
    g.drawImage(S.src, -S.W / 2, -S.H / 2);
    c.__jpcId = 'c' + (++cropSeq);
    return c;
  }
  function orient(c, vertical) {
    if (!vertical) return c;
    var v = document.createElement('canvas'); v.width = c.height; v.height = c.width;
    var g = v.getContext('2d');
    g.translate(v.width, 0); g.rotate(Math.PI / 2);
    g.drawImage(c, 0, 0);
    return v;
  }

  var pvT;
  function schedulePreview() {
    clearTimeout(pvT);
    pvT = setTimeout(function () {
      if (!S.src || !pvCanvas || !FW) return;
      var c = renderCrop(S, 900);
      if (!drawPhotoMock(pvCanvas, c)) drawMock(pvCanvas, c, 520);
      q('[data-jpc="pvt"]', M).textContent = 'On your ' + kindLabel();
      q('[data-jpc="pvm"]', M).textContent = materialLabel();
    }, 60);
  }

  function hideHint() { if (hintEl) hintEl.classList.add('is-off'); }

  /* ---------------- gestures ---------------- */
  function bindGestures() {
    var pts = {}, startDist = 0, startS = 0, last = null, mid = null;
    function local(e) { var r = stage.getBoundingClientRect(); return { x: e.clientX - r.left - FX, y: e.clientY - r.top - FY }; }
    stage.addEventListener('pointerdown', function (e) {
      if (!S.src) return;
      try { stage.setPointerCapture(e.pointerId); } catch (er) {}
      pts[e.pointerId] = local(e);
      var ids = Object.keys(pts);
      if (ids.length === 1) { last = pts[e.pointerId]; stage.classList.add('is-drag'); }
      if (ids.length === 2) {
        var a = pts[ids[0]], b = pts[ids[1]];
        startDist = Math.hypot(a.x - b.x, a.y - b.y) || 1; startS = S.s;
        mid = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
      }
      hideHint();
      e.preventDefault();
    });
    stage.addEventListener('pointermove', function (e) {
      if (!(e.pointerId in pts)) return;
      var p = local(e);
      pts[e.pointerId] = p;
      var ids = Object.keys(pts);
      if (ids.length === 1 && last) {
        S.cx += p.x - last.x; S.cy += p.y - last.y; last = p;
        clampAll(); draw();
      } else if (ids.length >= 2) {
        var a = pts[ids[0]], b = pts[ids[1]];
        var d = Math.hypot(a.x - b.x, a.y - b.y) || 1;
        var m2 = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
        S.cx += m2.x - mid.x; S.cy += m2.y - mid.y; mid = m2;
        zoomAbout(startS * d / startDist, m2.x, m2.y);
      }
      e.preventDefault();
    });
    function up(e) {
      delete pts[e.pointerId];
      var ids = Object.keys(pts);
      if (ids.length === 1) { last = pts[ids[0]]; }
      if (!ids.length) { last = null; stage.classList.remove('is-drag'); syncUI(); }
    }
    stage.addEventListener('pointerup', up);
    stage.addEventListener('pointercancel', up);
    stage.addEventListener('wheel', function (e) {
      if (!S.src) return;
      e.preventDefault();
      var p = local(e);
      zoomAbout(S.s * Math.exp(-e.deltaY * 0.0018), p.x, p.y);
      hideHint();
    }, { passive: false });
    stage.addEventListener('keydown', function (e) {
      var step = e.shiftKey ? 30 : 8, used = true;
      if (e.key === 'ArrowLeft') S.cx -= step;
      else if (e.key === 'ArrowRight') S.cx += step;
      else if (e.key === 'ArrowUp') S.cy -= step;
      else if (e.key === 'ArrowDown') S.cy += step;
      else if (e.key === '+' || e.key === '=') { zoomAbout(S.s * 1.1, 0, 0); return e.preventDefault(); }
      else if (e.key === '-' || e.key === '_') { zoomAbout(S.s / 1.1, 0, 0); return e.preventDefault(); }
      else used = false;
      if (used) { e.preventDefault(); clampAll(); draw(); hideHint(); }
    });
  }

  /* ---------------- hand the file to the app ---------------- */
  function toBlob(c) {
    return new Promise(function (res) {
      if (c.toBlob) c.toBlob(function (b) { res(b); }, 'image/jpeg', 0.92);
      else {
        var d = c.toDataURL('image/jpeg', 0.92), bin = atob(d.split(',')[1]), a = new Uint8Array(bin.length);
        for (var i = 0; i < bin.length; i++) a[i] = bin.charCodeAt(i);
        res(new Blob([a], { type: 'image/jpeg' }));
      }
    });
  }

  var waitT = null, sendSeq = 0;
  function sendFile(file, sentVertical) {
    var inp = appInput();
    if (!inp) { S.phase = 'error'; paintCard(); setMsg('Something went wrong loading the photo field. Please refresh the page.'); return; }
    var mine = ++sendSeq;
    S.phase = 'busy'; paintCard(); setMsg('');
    var old = appPreviewImg(inp);
    var oldSrc = old ? old.getAttribute('src') : null;
    // clear a previous upload in the app first so it never holds two
    if (old) {
      var rm = old.parentNode && old.parentNode.querySelector('button');
      if (rm) { try { rm.click(); } catch (e) {} }
    }
    later(function () {
      if (mine !== sendSeq) return;
      inp = appInput();
      try {
        var dt = new DataTransfer();
        dt.items.add(file);
        inp.files = dt.files;
      } catch (e) {
        S.phase = 'error'; paintCard();
        setMsg('Your browser blocked the photo upload. Please update your browser or try another one.');
        return;
      }
      inp.dispatchEvent(new Event('change', { bubbles: true }));
      var t0 = Date.now();
      clearInterval(waitT);
      waitT = setInterval(function () {
        if (mine !== sendSeq) { clearInterval(waitT); return; }
        var im = appPreviewImg(appInput());
        var src = im ? im.getAttribute('src') : null;
        if (src && src !== oldSrc) {
          clearInterval(waitT);
          S.phase = 'done'; S.sentStyle = sentVertical; paintCard();
          return;
        }
        if (Date.now() - t0 > 45000) {
          clearInterval(waitT);
          S.phase = 'error'; paintCard();
          setMsg('The photo did not finish uploading. Check your connection and tap Change photo to try again.');
        }
      }, 300);
    }, old ? 350 : 0);
  }

  function apply() {
    if (!S.src) return;
    S.crop = { s: S.s, cx: S.cx, cy: S.cy, r90: S.r90, tilt: S.tilt, fw: FW };
    S.cropCanvas = renderCrop(S);
    S.asIs = false;
    closeModalKeep();
    pushCrop(false);
  }
  function closeModalKeep() {
    if (!M) return;
    M.classList.remove('is-open');
    lockScroll(false);
    if (card) { try { q('.jpcrop1-box', card).scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {} }
  }
  // style switched after framing: keep their centre and zoom, refit to the new frame shape
  function reframe() {
    if (!S.crop || !S.src) return;
    var sFW = FW, sFH = FH;
    FW = S.crop.fw; FH = FW / ratio();
    S.s = S.crop.s; S.cx = S.crop.cx; S.cy = S.crop.cy; S.r90 = S.crop.r90; S.tilt = S.crop.tilt;
    clampAll();
    S.crop = { s: S.s, cx: S.cx, cy: S.cy, r90: S.r90, tilt: S.tilt, fw: FW };
    S.cropCanvas = renderCrop(S);
    FW = sFW; FH = sFH;
  }
  function pushCrop(isRestyle) {
    if (isRestyle) reframe();
    var vertical = isVertical();
    S.phase = 'busy'; S.sentStyle = vertical; paintCard();
    var out = orient(S.cropCanvas, vertical);
    toBlob(out).then(function (b) {
      var name = 'iris-' + (DATA.kind === 'bracelet' ? 'bracelet' : (vertical ? 'vertical' : 'horizontal')) + '-' + out.width + 'x' + out.height + '-' + Date.now().toString(36) + '.jpg';
      var f;
      try { f = new File([b], name, { type: 'image/jpeg', lastModified: Date.now() }); }
      catch (e) { f = b; f.name = name; }
      sendFile(f, vertical);
      if (isRestyle) toast(vertical ? 'Photo refitted to the vertical bar. Tap Adjust to fine tune.' : 'Photo refitted to the horizontal bar. Tap Adjust to fine tune.');
    });
  }
  function sendAsIs() {
    if (!S.file) return;
    S.asIs = true; S.cropCanvas = null; S.crop = null;
    closeModalKeep();
    sendFile(S.file, isVertical());
  }

  /* ---------------- add to cart guard ---------------- */
  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[type="submit"],button[name="add"],input[type="submit"],[data-add-to-cart]');
    if (!btn) return;
    var form = btn.form || btn.closest('form');
    if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    if (form.querySelector('[name="contact[email]"]')) return;
    if (!card) return;
    var inp = appInput();
    var has = !!appPreviewImg(inp);
    if (S.phase === 'busy') {
      e.preventDefault(); e.stopImmediatePropagation();
      toast('One moment, your photo is still saving');
      return;
    }
    if (!has) {
      e.preventDefault(); e.stopImmediatePropagation();
      setMsg('Add a photo of their eyes to continue.');
      var bx = q('.jpcrop1-box', card);
      bx.classList.remove('is-pulse'); void bx.offsetWidth; bx.classList.add('is-pulse');
      try { bx.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (er) {}
    }
  }, true);

  /* ---------------- watch the app and the variant ---------------- */
  var reTries = 0, lastAppErr = '';
  function tick() {
    if (!mountCard()) return;
    // the app flags a missing photo in its own hidden line; show it in our card instead
    var w = appWrap(appInput());
    var errEl = w ? w.querySelector(':scope > span.danger') : null;
    var appErr = errEl ? (errEl.textContent || '').trim() : '';
    if (appErr && appErr !== lastAppErr && S.phase !== 'done' && S.phase !== 'busy') {
      setMsg('Add a photo of their eyes to continue.');
      var bx = q('.jpcrop1-box', card);
      bx.classList.remove('is-pulse'); void bx.offsetWidth; bx.classList.add('is-pulse');
    }
    lastAppErr = appErr;
    var vid = currentVariantId();
    if (vid !== S.lastVariant) {
      var first = S.lastVariant === null;
      S.lastVariant = vid;
      if (!first) {
        paintCard();
        if (M && M.classList.contains('is-open')) { if (S.src) { layout(); clampAll(); syncUI(); draw(); } else schedulePreview(); }
      }
    }
    // style switched after cropping: refit the crop to the new bar shape and re-upload
    if (S.phase === 'done' && S.cropCanvas && !S.asIs && S.sentStyle !== isVertical()) { pushCrop(true); return; }
    // the app re-renders its field sometimes: if our upload vanished, put it back
    if (S.phase === 'done' && !appPreviewImg(appInput())) {
      if (reTries < 2) {
        reTries++;
        if (S.cropCanvas && !S.asIs) pushCrop(false); else if (S.file) sendFile(S.file, isVertical());
      } else { S.phase = 'idle'; paintCard(); }
    } else if (S.phase === 'done') { reTries = 0; }
  }

  function start() {
    tick();
    var mo = new MutationObserver(function () { setTimeout(tick, 0); });
    mo.observe(document.body, { childList: true, subtree: true });
    setInterval(tick, 500);
    document.addEventListener('visibilitychange', tick);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
